import React from "react";

const TabButtons = ({
  options,
  selectedOption,
  onSelect,
  count,
  page,
  userCount,
}) => {
  return (
    <div className="flex justify-around">
      {options.map((option, index) => {
        const isSecondTab = index === 1;
        const isDisabled = isSecondTab && userCount <= 0;

        return (
          <div
            key={option.value}
            className={`flex-[0.6] p-1 h-8 rounded-xl shadow-md mx-1.5 mt-1 
              text-center flex justify-center items-center bg-white
              ${isDisabled ? "cursor-not-allowed opacity-50" : "cursor-pointer"}
              ${page === "mct" ? "font-poppins" : ""}
            `}
            onClick={() => {
              if (!isDisabled) onSelect(option.value);
            }}
          >
            <p
              className={
                selectedOption === option.value
                  ? "text-indigo-600 text-[15px] font-semibold font-poppins"
                  : "text-[14px] text-[#AAAAAB] font-poppins"
              }
            >
              {option.label} {option.count !== 0 && option.count}
            </p>
          </div>
        );
      })}
    </div>
  );
};

export default TabButtons;
